module.exports = require('./helpers/bundle-url').getBundleURL('4ZtNJ') + "search-empty.30342eab.svg";